var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classNames,attrs:{"data-test-alert":""}},[_c('span',{class:_vm.iconClassNames,attrs:{"data-test-alert-icon":""}}),_c('span',{staticClass:"adn-alert__text",attrs:{"data-test-alert-text":""}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }